import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isEmpty } from 'lodash';
import { ExportRequest } from 'src/app/shared/model/export-request';
import { FileType } from 'src/app/shared/model/file-type';

@Component({
  selector: 'app-export-data',
  templateUrl: './export-data.component.html',
  styleUrls: ['./export-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExportDataComponent implements OnInit {

  exportDataTypes: FileType[];
  cron: string | null = null;
  dataType: FileType | null = null;
  fileName: string = null;

  constructor(public dialogRef: MatDialogRef<ExportDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { exportDataTypes: FileType[]; isSchedule: boolean; title: string }) { }

  ngOnInit(): void {
    this.exportDataTypes = this.data.exportDataTypes;
    if (this.exportDataTypes.length === 1)
      this.dataType = this.exportDataTypes[0];
  }

  setCron(cron: string): void {
    this.cron = cron;
  }

  canSubmit(): boolean {
    return !isEmpty(this.dataType) && (!this.data.isSchedule || !isEmpty(this.cron));
  }

  onSubmit(): void {
    this.dialogRef.close(new ExportRequest(this.dataType, this.cron, this.fileName));
  }

}
